import { FC, ReactElement } from 'react'
import type { MessageListNotificationsProps } from 'stream-chat-react'
import { ConnectionStatus, useChannelStateContext } from 'stream-chat-react'

import { ScrollToBottomButton } from '@/containers/MessageDetailContainer/subcomponents/ScrollToBottomButton/ScrollToBottomButton'
import { useScrollFollow } from '@/context/ScrollFollowContext'

export const ConversationListNotifications: FC<MessageListNotificationsProps> = ({
    notifications,
}): ReactElement => {
    const { isScrolledAway, scrollToBottom } = useScrollFollow()
    const { channelUnreadUiState } = useChannelStateContext()

    return (
        <div className="str-chat__list-notifications">
            {notifications.map(notification => (
                <div
                    key={notification.id}
                    aria-live="polite"
                    className={`str-chat__custom-notification notification-${notification.type} str-chat__notification`}
                >
                    {notification.text}
                </div>
            ))}
            <ConnectionStatus />
            <ScrollToBottomButton
                onClick={scrollToBottom}
                showNotification={isScrolledAway}
                unreadCount={channelUnreadUiState?.unread_messages}
            />
        </div>
    )
}
